import { render, staticRenderFns } from "./TalksRecordWin.vue?vue&type=template&id=74d5c3a8"
import script from "./TalksRecordWin.vue?vue&type=script&lang=js"
export * from "./TalksRecordWin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports